var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "RewardCardList",
      "extra-items": [{
        text: _vm.rewardCard.title,
        to: 'RewardCardView',
        params: _vm.$route.params.reward_card_id
      }, '集點任務']
    }
  })], 1)]), _c('b-card', [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm.rewardCard ? [_vm._v(" 【" + _vm._s(_vm.rewardCard.title) + "】 ")] : _vm._e(), _vm._v(" 集點任務管理 ")], 2), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-button', {
    staticClass: "flex-shrink-0 mr-2",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.allMissionsModal.show();
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-qrcode"
  }), _vm._v(" 全任務核銷碼 ")]), _vm.checkPermission([_vm.consts.REWARD_MISSION_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mr-2",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'RewardMissionCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增集點任務")]) : _vm._e()], 1)]), _c('b-card-text', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.rewardMissions,
      "fields": _vm.fields
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "cell(start_end_time)",
      fn: function fn(data) {
        return [data.item.period_type == 'custom' ? [_c('div', [_vm._v(" " + _vm._s(_vm.dateFormatter(data.item.start_at)) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.dateFormatter(data.item.end_at)) + " ")])] : [_c('div', [_vm._v(" " + _vm._s(_vm.dateFormatter(_vm.rewardCard.start_at)) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.dateFormatter(_vm.rewardCard.end_at)) + " ")])]];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('copy-url-button', {
          staticClass: "mr-1",
          attrs: {
            "url": _vm.generateLiffUrl("".concat(_vm.getMissionUrl(data.item))),
            "title": data.item.title
          },
          scopedSlots: _vm._u([{
            key: "qrcode",
            fn: function fn() {
              return [_c('div', {
                staticClass: "d-flex flex-column align-items-center"
              }, [_c('vue-qr', {
                ref: "qrcode",
                attrs: {
                  "text": _vm.generateLiffUrl("".concat(_vm.getMissionUrl(data.item)))
                }
              })], 1)];
            },
            proxy: true
          }, {
            key: "qrcode-download-button",
            fn: function fn() {
              return [_c('b-button', {
                attrs: {
                  "variant": "primary"
                },
                on: {
                  "click": function click($event) {
                    return _vm.downloadQRCode(data.item.title);
                  }
                }
              }, [_vm._v(" 下載QRCode ")])];
            },
            proxy: true
          }], null, true)
        }), _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-info",
            "to": {
              name: 'RewardMissionPointLog',
              params: {
                reward_card_id: _vm.rewardCardId,
                reward_mission_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-account-multiple"
        }), _vm._v(" 點數紀錄 ")]), _vm.checkPermission([_vm.consts.REWARD_MISSION_LIST_VIEW]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'RewardMissionView',
              params: {
                reward_card_id: _vm.rewardCardId,
                reward_mission_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.REWARD_MISSION_MODIFY]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'RewardMissionEdit',
              params: {
                reward_card_id: _vm.rewardCardId,
                reward_mission_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.REWARD_MISSION_DELETE]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteRewardMission(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }])
  })], 1), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "update:currentPage": function updateCurrentPage($event) {
        return _vm.$set(_vm.query, "page", $event);
      },
      "update:current-page": function updateCurrentPage($event) {
        return _vm.$set(_vm.query, "page", $event);
      },
      "update:perPage": function updatePerPage($event) {
        return _vm.$set(_vm.query, "per_page", $event);
      },
      "update:per-page": function updatePerPage($event) {
        return _vm.$set(_vm.query, "per_page", $event);
      }
    }
  })], 1)], 1), _c('b-modal', {
    ref: "allMissionsModal",
    attrs: {
      "footer-class": "d-flex justify-content-center"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('h5', {
          staticClass: "m-0 align-self-center"
        }, [_vm.rewardCard ? [_vm._v("【" + _vm._s(_vm.rewardCard.title) + "】")] : _vm._e(), _vm._v("全任務核銷碼 ")], 2), _c('b-button', {
          staticClass: "text-dark",
          attrs: {
            "size": "sm",
            "variant": "link"
          },
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_c('svg', {
          staticStyle: {
            "height": "20px"
          },
          attrs: {
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 320 512"
          }
        }, [_c('path', {
          attrs: {
            "d": "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
          }
        })])])];
      }
    }, {
      key: "modal-footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "modal-button-group"
        }, [_c('div', {
          staticClass: "center-button"
        }, [_c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.downloadAllMissionsQRCode
          }
        }, [_vm._v("下載QRCode")])], 1), _c('b-button', {
          attrs: {
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.$refs.allMissionsModal.hide();
            }
          }
        }, [_vm._v("關閉")])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-textarea', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.click",
      value: '已複製',
      expression: "'已複製'",
      modifiers: {
        "click": true
      }
    }],
    ref: "allMissionsUrl",
    staticClass: "form-control",
    attrs: {
      "value": _vm.allMissionsUrl,
      "readonly": ""
    },
    on: {
      "click": _vm.copyAllMissionsUrl
    }
  }), _c('div', {
    staticClass: "d-flex flex-column align-items-center mt-3"
  }, [_c('vue-qr', {
    ref: "allMissionsQrcode",
    attrs: {
      "text": _vm.allMissionsUrl
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }